import { render, staticRenderFns } from "./orderDetails.pug?vue&type=template&id=7c6e17cb&lang=pug&"
import script from "./orderDetails.ts?vue&type=script&lang=ts&"
export * from "./orderDetails.ts?vue&type=script&lang=ts&"
import style0 from "./orderDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports